import React from "react";
import { ValueDisplay, ValueDisplayProps } from "./ValueDisplay";

interface InlineValueDisplayListProps {
	//a list of Value Display Items
	displayItems: ValueDisplayProps[];
	// should falsy values be rendered
	shouldSkipEmptyValues?: boolean;
	// amount of bottom spacing between items in px
	bottomSpacing?: number;
}

/**
 * Accepts a list of ValueDisplayProps to be displayed side by side
 * to each other wrapping upon reaching the end of the container.
 * @param props
 */
export const InlineValueDisplayList = (props: InlineValueDisplayListProps) => (
	<div style={{ display: "flex", flexWrap: "wrap" }}>
		{props.displayItems
			.filter((i) => i.node || !props.shouldSkipEmptyValues)
			.map((item, key) => (
				<div
					key={key}
					data-testid="value-display-item"
					style={{ marginRight: 24, marginBottom: props.bottomSpacing || 4 }}
				>
					<ValueDisplay label={item.label} node={item.node} row={item.row}></ValueDisplay>
				</div>
			))}
	</div>
);
